import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export interface StartMiniTournamentNowPayload {
  meetingId: string;
  occurenceId: string;
  tournament_id: number;
  join_coach?: boolean;
}

export type StartMiniTournamentStatus = 'started' | 'imminent';

export interface StartMiniTournamentNowResponse {
  success: boolean;
  status?: StartMiniTournamentStatus;
  tournament_id?: number;
  effective_start_date?: string;
  coach_joined?: boolean;
  error?: string;
}

export default function useStartMiniTournamentNowApi(
  handleOnSuccess?: (data: StartMiniTournamentNowResponse) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<
  StartMiniTournamentNowResponse,
  unknown,
  StartMiniTournamentNowPayload
> {
  return useMutation<
    StartMiniTournamentNowResponse,
    unknown,
    StartMiniTournamentNowPayload
  >(
    async (payload: StartMiniTournamentNowPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/start_mini_tournament_now/',
        payload,
      );
      return response.data;
    },
    {
      onSuccess: (data: StartMiniTournamentNowResponse) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to start mini tournament now:', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
